import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { Sidebar } from "primereact/sidebar";

import commonStyle from "../../components/content/CommonStyles.module.css";
import { useFormik } from "formik";
import { InputNumber } from "primereact/inputnumber";
import useApi from "../../Utils/BackendClient";
import { useState } from "react";
import { ProgressSpinner } from "primereact/progressspinner";

const DocumentPrintSidebar = ({ sbVisible, onHide, actData, toast }) => {

    const [loading, setLoading] = useState(false);

    const { generateDocumentTemplate } = useApi();

    const formik = useFormik({
        initialValues: {
            template_id: null,
            entity_id: actData?.id,
            quantity: 1
        },
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            return errors;
        },
        onSubmit: async (values) => {

            setLoading(true);

            const response = await generateDocumentTemplate([values]);

            if (response.status === 200) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);

                const link = document.createElement('a');
                link.href = url;

                const docName = dropdownOptions.find(x => x.value === values.template_id).label;

                link.download = `${docName}-${actData.id}.pdf`;
                document.body.appendChild(link);
                link.click();

                // Clean up
                link.remove();
                window.URL.revokeObjectURL(url);
                
                toast.current.show({ severity: 'success', summary: 'Створення документу', detail: 'Документ створено', life: 3000 });
                setLoading(false);

                onHide();
            }
            else {
                setLoading(false);
                toast.current.show({ severity: "error", summary: "Створення документу", detail: "Документ не створено", life: 3000 });
                onHide();
            }
        }
    });

    const dropdownOptions = actData && actData.templates ? Object.values(actData.templates).map(templates => ({
        label: templates.name,
        value: templates.id
    })) : null;

    return <Sidebar visible={sbVisible} onHide={onHide} position="right">
        {loading ? (<div className="flex align-items-center justify-content-center"><ProgressSpinner /></div>) :
            (<form onSubmit={formik.handleSubmit}>
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <Dropdown
                            value={formik.values.template_id}
                            onChange={e => formik.setFieldValue("template_id", e.value)}
                            options={dropdownOptions}
                            placeholder="Виберіть документ"
                            className="p-column-filter w-full"
                            showClear
                        />
                        <label>Документ</label>
                    </FloatLabel>
                </div>
                <div className="col-12 mt-3">
                    <FloatLabel>
                        <InputNumber
                            minFractionDigits={0}
                            value={formik.values.quantity}
                            onChange={e => formik.setFieldValue("quantity", e.value)}
                        />
                        <label>Кількість</label>
                    </FloatLabel>
                </div>
                <Button className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} label="Друкувати" type="submit" />
            </form>)
        }
    </Sidebar >
}

export default DocumentPrintSidebar;